import React from 'react';
import {BadgeRarity as Rarity} from '../services/badgeApi';
export default function BadgeRarity({value}:{value?:Rarity}){
 if(!value)return null;
 return <p className="text-xs text-gray-500 mt-3">{value.earned_percent}% have earned this · {value.earned_count} {value.earned_count===1?'member':'members'}</p>;
}
